import React from "react";
import ModalFormGasto from "./ModalFormGasto";

const ModalGasto = ({ show, handleClose, gasto }) => {
  return (
    <ModalFormGasto show={show} handleClose={handleClose} gasto={gasto} />
  );
};

export default ModalGasto;
